
<template>
  <div>
    <!-- MAIN MODAL -->
    <b-modal
      v-if="downloading && !isMinimized"
      :visible="downloading"
      @hide="onClose"
      title="Generating Report"
      hide-footer
      centered
    >

    <template #modal-header="{ close }">
    <div class="modal-header-custom d-flex justify-content-between align-items-center w-100">
      <strong>Generating Report</strong>

      <div class="header-actions">
        <!-- Minimize icon -->
        <button
          class="circle-btn"
          style="margin-right: 8px;"
          title="Minimize"
          @click.stop="minimize"
        >
          —
        </button>

        <!-- Close icon -->
        <button
          class="circle-btn danger"
          title="Cancel"
          @click.stop="close()"
        >
          ✕
        </button>
      </div>
    </div>
  </template>

      <b-card
       class="mb-0"
      >
        <h6 class="mb-1">Please wait while we generate your report…</h6>

        <b-progress
          :value="percent"
          :max="100"
          height="8px"
          animated
          show-value
        />

        <small class="text-muted mt-1 d-block">
          {{ percent.toFixed(1) }}%
        </small>
      </b-card>
    </b-modal>

    <!-- FLOATING WIDGET -->
    <div v-if="downloading && isMinimized" class="floating-report">
      <div class="floating-header">
        <strong>Generating Report</strong>
        <div class="actions">
          <button  class="circle-btn"
          title="Restore" @click="restore">—</button>
          
          <button class="circle-btn danger" @click="cancel">✕</button>
        </div>
      </div>

      <b-progress :value="percent" :max="100" height="6px" animated />
      <small class="text-muted">{{ percent.toFixed(1) }}%</small>
    </div>
  </div>
</template>

<script>
import { reportAbort } from '@/views/pages/ReportBuilder/reportAbort';
import { mapState, mapMutations } from 'vuex'

export default {

  watch: {
    '$store.state.report.cancelRequested'(val) {
      if (val) {
        window.dispatchEvent(new CustomEvent('abort-report'))
        this.finish()
      }
    }
  },

  computed: {
    ...mapState('report', [
      'downloading',
      'isMinimized',
      'percent',
    ]),
  },

  methods: {
    ...mapMutations('report', {
      minimize: 'MINIMIZE',
      restore: 'RESTORE',
      requestCancel: 'REQUEST_CANCEL',
      finish: 'FINISH',
    }),

    abortReport() {
      window.dispatchEvent(new CustomEvent('abort-report'))
      this.finish()
    },

    async cancel() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'Are you sure you want to cancel ?',
        {
          title: 'Cancel Report',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes, Cancel',
          cancelTitle: 'No',
          centered: true,
        }
      )

      if (confirmed) {
        this.requestCancel() 
      }
    },

    async onClose(bvEvt) {
      if (!this.downloading) return

      bvEvt.preventDefault()
      await this.cancel()
    },
  },

  mounted() {
    this.abortListener = () => {
      if (reportAbort.controller) {
        reportAbort.controller.abort();
        reportAbort.controller = null;
      }
    };

    window.addEventListener("abort-report", this.abortListener);
  },
}
</script>

<style scoped>
.floating-report {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 260px;
  background: #fff;
  border-radius: 10px;
  padding: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  z-index: 9999;
}

.floating-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.actions {
  display: flex;
  gap: 6px;
}

.circle-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #e5e7eb;
  cursor: pointer;
}

.circle-btn.danger {
  background: #fee2e2;
}
</style>
